import React, { useEffect } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';
import i18n from '@i18n';
import imports from '@/routing/imports';
import { charityCleanup, loadCharityData } from '@/charity/handlers';

const Counter = React.lazy(() => imports.charityCounter().then(_ => ({ ..._, default: _.Counter })));
const Spacer = React.lazy(() => imports.charityCounter().then(_ => ({ ..._, default: _.Spacer })));

const CharityCounterModule = () => {
    const derefSub = useReframe();
    const charityValue = derefSub(['charity.value']);

    useEffect(() => {
        dispatch(loadCharityData);
        return () => dispatch(charityCleanup);
    }, []);

    return (
        <div className={'charity-counter-box cms-module'}>
            <div className="charity-counter">
                <div className={'layer one'}>
                    <React.Suspense fallback={null}>
                        <Spacer />
                        {charityValue > 0 && <Counter />}
                    </React.Suspense>
                </div>
                <div className={'layer two'}>
                    <div className="text">{i18n('charity.counter.message')}</div>
                </div>
            </div>
        </div>
    );
};

export default CharityCounterModule;
